import { render } from "./BlockToast.vue?vue&type=template&id=384b0ff0"
import script from "./BlockToast.vue?vue&type=script&lang=js"
export * from "./BlockToast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__